export default __webpack_public_path__ + "static/media/caret-img.8bd72244.svg";